export default "__VITE_ASSET__CT91Ydfj__"